import { resolveComponent as _resolveComponent, createVNode as _createVNode, withKeys as _withKeys, withModifiers as _withModifiers, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createSlots as _createSlots, createBlock as _createBlock, Fragment as _Fragment } from "vue"

const _hoisted_1 = { key: 0 }
const _hoisted_2 = {
  class: "c-form-control-checkbox__label",
  for: "schlusserklaerungMakler2"
}
const _hoisted_3 = { class: "c-form-control-checkbox__label-text" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Steps = _resolveComponent("Steps")!
  const _component_titel_zelle = _resolveComponent("titel-zelle")!
  const _component_zelle = _resolveComponent("zelle")!
  const _component_zeile = _resolveComponent("zeile")!
  const _component_icon_sprite = _resolveComponent("icon-sprite")!
  const _component_abschluss = _resolveComponent("abschluss")!
  const _component_modal = _resolveComponent("modal")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_Steps, {
      active: 3,
      items: _ctx.navItems,
      onGotoPage: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('goto-page', $event)))
    }, null, 8, ["items"]),
    _createVNode(_component_abschluss, {
      produkt: "phv",
      "zeige-versicherte-person": true,
      onNextPage: _cache[6] || (_cache[6] = ($event: any) => (_ctx.$emit('next-page', $event))),
      onGotoPage: _cache[7] || (_cache[7] = ($event: any) => (_ctx.$emit('goto-page', $event)))
    }, _createSlots({
      "info-1": _withCtx(() => [
        _createVNode(_component_zeile, { class: "u-mar-t-2" }, {
          default: _withCtx(() => [
            _createVNode(_component_titel_zelle, {
              "ausrichtung-responsiv": false,
              breite: 3,
              "vertikal-zentrieren": false,
              class: "o-grid__cell--4"
            }, {
              default: _withCtx(() => [
                _cache[9] || (_cache[9] = _createTextVNode(" De­ckungs­sum­me  ")),
                _createElementVNode("a", {
                  role: "button",
                  tabindex: "0",
                  class: "u-copy-s field-edit",
                  onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.geheZuVergleich && _ctx.geheZuVergleich(...args))),
                  onKeydown: [
                    _cache[2] || (_cache[2] = _withKeys(
//@ts-ignore
(...args) => (_ctx.geheZuVergleich && _ctx.geheZuVergleich(...args)), ["enter"])),
                    _cache[3] || (_cache[3] = _withKeys(_withModifiers(
//@ts-ignore
(...args) => (_ctx.geheZuVergleich && _ctx.geheZuVergleich(...args)), ["prevent"]), ["space"]))
                  ],
                  "aria-label": "Deckungssumme bearbeiten"
                }, "bearbeiten", 32)
              ]),
              _: 1,
              __: [9]
            }),
            _createVNode(_component_zelle, {
              breite: 9,
              class: "o-grid__cell--8",
              "data-cy": "deckungssumme"
            }, {
              default: _withCtx(() => [
                _createElementVNode("strong", null, _toDisplayString(_ctx.getPhvDeckungssumme), 1)
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ]),
      "angaben-bestaetigen": _withCtx(() => [
        _cache[14] || (_cache[14] = _createTextVNode(" Ja, der Antrag wurde gemäß meinen Angaben erstellt. ")),
        (_ctx.hatZusatzmodule)
          ? (_openBlock(), _createElementBlock("span", _hoisted_1, [
              _cache[12] || (_cache[12] = _createTextVNode("Mein Hund ist kein ")),
              _createElementVNode("a", {
                onClick: _cache[4] || (_cache[4] = _withModifiers(($event: any) => (_ctx.wechsleSichtbarkeit('kampfUndListenhunde')), ["stop","prevent"]))
              }, "Kampf- oder Listenhund"),
              _cache[13] || (_cache[13] = _createTextVNode(" einschließlich Kreuzungen aus diesen Rassen. "))
            ]))
          : _createCommentVNode("", true),
        _cache[15] || (_cache[15] = _createTextVNode(" Auf eine Beratung habe ich verzichtet und damit auf den Schadenersatzanspruch nach §6. Abs. 5 VVG. "))
      ]),
      _: 2
    }, [
      (_ctx.hatZusatzmodule)
        ? {
            name: "zusatzmodule",
            fn: _withCtx(() => [
              _cache[10] || (_cache[10] = _createElementVNode("br", null, null, -1)),
              _cache[11] || (_cache[11] = _createTextVNode("mit Hundehalterhaftpflicht "))
            ]),
            key: "0"
          }
        : undefined,
      (_ctx.piniaStore.state.isMakler && _ctx.hatZusatzmodule)
        ? {
            name: "schlusserklaerungMakler2",
            fn: _withCtx(() => [
              _cache[18] || (_cache[18] = _createElementVNode("input", {
                type: "checkbox",
                class: "c-form-control-checkbox__input",
                id: "schlusserklaerungMakler2",
                name: "schlusserklaerungMakler2",
                required: "",
                "aria-required": "true",
                "aria-label": "Bitte bestätigen Sie die Erklärung.",
                "data-fehlermeldung": "Bitte bestätigen Sie die Erklärung.",
                "data-cy": "schlusserklaerungMakler2"
              }, null, -1)),
              _createElementVNode("label", _hoisted_2, [
                _createVNode(_component_icon_sprite, {
                  "ist-klein": true,
                  "css-klassen": "c-form-control-checkbox__icon",
                  "icon-name": "icon-check-mark"
                }),
                _createElementVNode("span", _hoisted_3, [
                  _cache[16] || (_cache[16] = _createTextVNode(" Der/die Versicherungsmakler/in bestätigt, dass die Hunderasse geprüft wurde. Der Hund seines Mandanten ist kein ")),
                  _createElementVNode("a", {
                    onClick: _cache[5] || (_cache[5] = _withModifiers(($event: any) => (_ctx.wechsleSichtbarkeit('kampfUndListenhunde')), ["stop","prevent"]))
                  }, " Kampf- oder Listenhund "),
                  _cache[17] || (_cache[17] = _createTextVNode(" einschließlich Kreuzungen aus diesen Rassen. "))
                ])
              ])
            ]),
            key: "1"
          }
        : undefined
    ]), 1024),
    (_ctx.istSichtbar('kampfUndListenhunde'))
      ? (_openBlock(), _createBlock(_component_modal, {
          key: 0,
          id: "kampfUndListenhunde",
          titel: "Kampf- und Listenhunde",
          text: "Alano, American Bulldog, (American) Pit Bull Terrier, American\n                Staffordshire Terrier, Bandog, Bullmastiff, Bullterrier, Cane\n                Corso / Cane Corso Italiano, Dobermann, Dogo Argentino, Dogue de\n                Bordeaux (Boreauxdogge), Fila Brasileiro, Kangal, Kaukasischer\n                Owtscharka, Mastiff, Mastin Espanol, Mastino Napoletano, Perro\n                de Presa Canario (Dogo Canario), Perro de Presa Mallorquin (Ca\n                de Bou), Rottweiler, Staffordshire Bullterrier, Tosa Inu, sowie\n                Kreuzungen der genannten Rassen untereinander oder mit anderen\n                Hunden.",
          onCloseModal: _cache[8] || (_cache[8] = ($event: any) => (_ctx.wechsleSichtbarkeit('kampfUndListenhunde')))
        }))
      : _createCommentVNode("", true)
  ], 64))
}